export default class Parameter {
  key: string;
  paramIndex: number;

  constructor(key: string, paramIndex: number) {
    this.key = key;
    this.paramIndex = paramIndex;
  }
}
